/**
 * Overlok Render Motoru — Bağımsız
 * Bordürlü fotoğraftan bordür bölgesini halı dokusuyla kaplayarak
 * overlok görünümü oluşturur. preview.min.js'e DOKUNMAZ.
 */
(function() {
  'use strict';

  var BG_BRIGHTNESS = 245;

  function loadImg(url, cb) {
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function() { cb(img); };
    img.onerror = function() {
      // Retry without crossOrigin
      var img2 = new Image();
      img2.onload = function() { cb(img2); };
      img2.onerror = function() { console.warn('[OverlokRender] Image load fail:', url); };
      img2.src = url;
    };
    img.src = url;
  }

  function renderOverlok(sourceImg) {
    // Work at scaled resolution
    var scale = Math.min(1, 2400 / Math.max(sourceImg.naturalWidth, sourceImg.naturalHeight));
    var w = Math.round(sourceImg.naturalWidth * scale);
    var h = Math.round(sourceImg.naturalHeight * scale);

    var c = document.createElement('canvas');
    c.width = w; c.height = h;
    var ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(sourceImg, 0, 0, w, h);
    var imgData = ctx.getImageData(0, 0, w, h);
    var d = imgData.data;

    // Brightness map
    var brMap = new Float32Array(w * h);
    for (var i = 0; i < w * h; i++) {
      brMap[i] = (d[i*4] + d[i*4+1] + d[i*4+2]) / 3;
    }

    // BG mask via flood fill from edges
    var mask = new Uint8Array(w * h);
    for (var mi = 0; mi < w * h; mi++) mask[mi] = 1;
    var bgQ = [];
    for (var bx = 0; bx < w; bx++) {
      if (brMap[bx] >= BG_BRIGHTNESS) { mask[bx] = 0; bgQ.push(bx); }
      var bi = (h-1)*w+bx;
      if (brMap[bi] >= BG_BRIGHTNESS) { mask[bi] = 0; bgQ.push(bi); }
    }
    for (var by = 1; by < h-1; by++) {
      if (brMap[by*w] >= BG_BRIGHTNESS) { mask[by*w] = 0; bgQ.push(by*w); }
      var ri = by*w+(w-1);
      if (brMap[ri] >= BG_BRIGHTNESS) { mask[ri] = 0; bgQ.push(ri); }
    }
    while (bgQ.length > 0) {
      var nxt = [];
      for (var qi = 0; qi < bgQ.length; qi++) {
        var ci = bgQ[qi], cx = ci%w, cy = (ci/w)|0;
        for (var dy = -1; dy <= 1; dy++) {
          for (var dx = -1; dx <= 1; dx++) {
            if (dx===0 && dy===0) continue;
            var nx = cx+dx, ny = cy+dy;
            if (nx<0||nx>=w||ny<0||ny>=h) continue;
            var ni = ny*w+nx;
            if (mask[ni]===0) continue;
            if (brMap[ni] >= BG_BRIGHTNESS) { mask[ni]=0; nxt.push(ni); }
          }
        }
      }
      bgQ = nxt;
    }

    // Distance transform
    var distMap = new Int16Array(w * h);
    for (var di = 0; di < w*h; di++) distMap[di] = -1;
    var queue = [];
    for (var si = 0; si < w*h; si++) {
      if (mask[si]===0) {
        distMap[si]=0;
        var sx=si%w, sy=(si/w)|0, hasNb=false;
        for (var sdy=-1;sdy<=1&&!hasNb;sdy++) for (var sdx=-1;sdx<=1&&!hasNb;sdx++) {
          var snx=sx+sdx,sny=sy+sdy;
          if(snx>=0&&snx<w&&sny>=0&&sny<h&&mask[sny*w+snx]===1) hasNb=true;
        }
        if(hasNb) queue.push(si);
      }
    }
    var maxDist = 0;
    while (queue.length > 0) {
      var nq = [];
      for (var qj=0;qj<queue.length;qj++) {
        var cj=queue[qj],cjx=cj%w,cjy=(cj/w)|0,cd=distMap[cj];
        for (var ddy=-1;ddy<=1;ddy++) for (var ddx=-1;ddx<=1;ddx++) {
          if(ddx===0&&ddy===0) continue;
          var nnx=cjx+ddx,nny=cjy+ddy;
          if(nnx<0||nnx>=w||nny<0||nny>=h) continue;
          var nni=nny*w+nnx;
          if(distMap[nni]!==-1) continue;
          distMap[nni]=cd+1;
          if(cd+1>maxDist) maxDist=cd+1;
          nq.push(nni);
        }
      }
      queue = nq;
    }

    // Carpet bounds
    var cLeft=w,cRight=0,cTop=h,cBottom=0;
    for (var cby=0;cby<h;cby++) for (var cbx=0;cbx<w;cbx++) {
      if(mask[cby*w+cbx]!==0) {
        if(cbx<cLeft) cLeft=cbx; if(cbx>cRight) cRight=cbx;
        if(cby<cTop) cTop=cby; if(cby>cBottom) cBottom=cby;
      }
    }

    // BG flood-fill başarısızlık algılama: oda fotoğrafında coverage > %75 → fallback
    var _qcOvl = (window.__OZEL_OLCU_CONFIG__ && window.__OZEL_OLCU_CONFIG__.qualityCode || '').toLowerCase();
    if (_qcOvl.indexOf('paradiso') < 0) {
      var _cpxOvl = 0;
      for (var _coii = 0; _coii < w*h; _coii++) { if (mask[_coii]) _cpxOvl++; }
      if (_cpxOvl / (w*h) > 0.75) {
        var _inOvl = (window.__OZEL_OLCU_CONFIG__ && window.__OZEL_OLCU_CONFIG__.previewParams
                      && window.__OZEL_OLCU_CONFIG__.previewParams.carpetInset) || 0.08;
        cLeft   = Math.round(w * _inOvl);
        cTop    = Math.round(h * _inOvl);
        cRight  = Math.round(w * (1 - _inOvl));
        cBottom = Math.round(h * (1 - _inOvl));
        // Sentetik mask: inset bounds içi=1, dışı=0
        for (var _mi2 = 0; _mi2 < w*h; _mi2++) {
          var _mx2 = _mi2%w, _my2 = (_mi2/w)|0;
          mask[_mi2] = (_mx2>=cLeft && _mx2<=cRight && _my2>=cTop && _my2<=cBottom) ? 1 : 0;
        }
        // distMap yeniden inşa: BFS from mask=0 boundary
        distMap = new Int16Array(w*h);
        for (var _dri = 0; _dri < w*h; _dri++) distMap[_dri] = -1;
        var _dq = [];
        for (var _dsi = 0; _dsi < w*h; _dsi++) {
          if (mask[_dsi] === 0) {
            distMap[_dsi] = 0;
            var _dsx=_dsi%w, _dsy=(_dsi/w)|0, _hasNb=false;
            for (var _dsdy=-1;_dsdy<=1&&!_hasNb;_dsdy++) for (var _dsdx=-1;_dsdx<=1&&!_hasNb;_dsdx++) {
              var _dsnx=_dsx+_dsdx,_dsny=_dsy+_dsdy;
              if(_dsnx>=0&&_dsnx<w&&_dsny>=0&&_dsny<h&&mask[_dsny*w+_dsnx]===1) _hasNb=true;
            }
            if (_hasNb) _dq.push(_dsi);
          }
        }
        while (_dq.length > 0) {
          var _nq2 = [];
          for (var _qi2=0;_qi2<_dq.length;_qi2++) {
            var _qp=_dq[_qi2],_qx=_qp%w,_qy=(_qp/w)|0,_qd=distMap[_qp];
            for (var _ddy=-1;_ddy<=1;_ddy++) for (var _ddx=-1;_ddx<=1;_ddx++) {
              if(_ddx===0&&_ddy===0) continue;
              var _nnx=_qx+_ddx,_nny=_qy+_ddy;
              if(_nnx<0||_nnx>=w||_nny<0||_nny>=h) continue;
              var _nni=_nny*w+_nnx;
              if(distMap[_nni]!==-1) continue;
              distMap[_nni]=_qd+1;
              _nq2.push(_nni);
            }
          }
          _dq = _nq2;
        }
        console.log('[OverlokRender] BG fallback, inset=' + _inOvl);
      }
    }

    // Bordur depth: ~8% of carpet width (detect existing border)
    var carpetW = cRight - cLeft;
    var carpetH = cBottom - cTop;
    var borderDepth = Math.round(Math.max(carpetW, carpetH) * 0.03);

    // Sample center texture (safe inner area)
    var innerLeft = cLeft + borderDepth + 10;
    var innerTop = cTop + borderDepth + 10;
    var innerRight = cRight - borderDepth - 10;
    var innerBottom = cBottom - borderDepth - 10;
    var sampleW = innerRight - innerLeft;
    var sampleH = innerBottom - innerTop;

    if (sampleW < 50 || sampleH < 50) {
      console.warn('[OverlokRender] Inner area too small, skipping');
      return null;
    }

    // Clone the image data and replace border pixels with inner texture
    var outData = ctx.getImageData(0, 0, w, h);
    var od = outData.data;

    for (var py = 0; py < h; py++) {
      for (var px = 0; px < w; px++) {
        var pi = py * w + px;
        if (mask[pi] === 0) continue; // background
        var dist = distMap[pi];
        if (dist < 0) continue;
        if (dist > borderDepth) continue; // inner carpet — keep original

        // This pixel is in border zone — replace with inner texture
        // Map to inner sample area (tile)
        var srcX = innerLeft + ((px - cLeft) % sampleW);
        var srcY = innerTop + ((py - cTop) % sampleH);
        if (srcX < innerLeft) srcX += sampleW;
        if (srcY < innerTop) srcY += sampleH;
        if (srcX >= innerRight) srcX = innerLeft + (srcX - innerLeft) % sampleW;
        if (srcY >= innerBottom) srcY = innerTop + (srcY - innerTop) % sampleH;

        var srcI = (srcY * w + srcX) * 4;
        var dstI = pi * 4;

        // Soft blend at border/inner boundary
        var blend = 1.0;
        var fadeZone = Math.max(5, Math.round(borderDepth * 0.30));
        if (dist > borderDepth - fadeZone) {
          blend = (borderDepth - dist) / fadeZone;
        }

        if (blend >= 1.0) {
          od[dstI] = od[srcI]; od[dstI+1] = od[srcI+1]; od[dstI+2] = od[srcI+2];
        } else {
          od[dstI] = Math.round(od[dstI] * (1-blend) + od[srcI] * blend);
          od[dstI+1] = Math.round(od[dstI+1] * (1-blend) + od[srcI+1] * blend);
          od[dstI+2] = Math.round(od[dstI+2] * (1-blend) + od[srcI+2] * blend);
        }
      }
    }

    ctx.putImageData(outData, 0, 0);

    // Overlok stitch: ince 0.5px cizgi, dist=3 kontur
    ctx.strokeStyle = 'rgba(160,155,150,0.12)';
    ctx.lineWidth = 0.5;
    ctx.beginPath();
    for (var sy2 = cTop; sy2 <= cBottom; sy2++) {
      for (var sx2 = cLeft; sx2 <= cRight; sx2++) {
        var si2 = sy2*w+sx2;
        if (mask[si2]===1 && distMap[si2]===3) {
          ctx.rect(sx2, sy2, 1, 1);
        }
      }
    }
    ctx.stroke();

    return c.toDataURL('image/jpeg', 0.92);
  }

  // Public API
  window.__ozelOlcuOverlok = {
    render: function(imgEl) {
      if (!imgEl || !imgEl.src) return;
      var originalSrc = imgEl.getAttribute('data-original-src') || imgEl.src;
      loadImg(originalSrc, function(loaded) {
        console.log('[OverlokRender] Processing', loaded.naturalWidth + 'x' + loaded.naturalHeight);
        var result = renderOverlok(loaded);
        if (result) {
          imgEl.src = result;
          imgEl.srcset = '';
          // Zoom/magnifier data guncelle
          var zoomSpan = document.querySelector('.zoom-data');
          if (zoomSpan && zoomSpan.hasAttribute('data-high-res-src')) zoomSpan.setAttribute('data-high-res-src', result);
          var zoomImg = document.querySelector('.hdt-enhanced-zoom-image');
          if (zoomImg) zoomImg.src = result;
          // Thumbnail da guncelle
          var thumb = document.querySelector('.hdt-product__thumb img, .hdt-thumbnail__item img');
          if (thumb) { thumb.src = result; thumb.srcset = ''; }
          console.log('[OverlokRender] Done');
        }
      });
    },
    restore: function(imgEl) {
      if (!imgEl) return;
      var orig = imgEl.getAttribute('data-original-src');
      if (orig) { imgEl.src = orig; imgEl.srcset = ''; }
    }
  };

  console.log('[OverlokRender] Motor yuklendi');
})();
